import * as actionCreators from "./actions";
import orderActionService from "../../services/orderActionService";
import orderSearchService from "../../services/orderSearchService";
import orderProcessingService from "../../services/orderProcessingService";

export function loadOrderActions(countryCode) {
	return function (dispatch) {
		return orderActionService.getOrderActions(countryCode).then(orderActions => {
			dispatch(actionCreators.setOrderActions(orderActions));
		});
	};
}

export function loadPrivilegeCountries(countries) {
	return function (dispatch) {
		dispatch(actionCreators.setPrivilegeCountries(countries));
	};
}

export function loadOrderDetails(orderNumber, countryCode) {
	return function (dispatch) {
		return orderSearchService.getOrderDetails(orderNumber, countryCode).then(orderDetails => {
			dispatch(actionCreators.setOrderDetails(orderDetails));
		});
	};
}

function resolveCompartment(pOrderNoSrc) {
	if (!pOrderNoSrc) {
		throw new Error("Can not resolve compartment/orderNoSrc!");
	}
	switch (pOrderNoSrc.toUpperCase().trim()) {
		case "A01":
			return "IKEA_EU";
		case "A02":
			return "IKEA_AP";
		case "A03":
			return "IKEA_NA";
		case "A04":
			return "IKEA_CN";
		case "A05":
			return "IKEA_RU";
		default:
			console.log(`OrderNoSrc unrecognized:  ${pOrderNoSrc}.`);
			throw Error("Order number source can not be mapped to region");
	}
}

export function processOrderAction() {
	return function (dispatch, getState) {
		const { orderDetails, selectedAction } = getState().orderCorrectionController;
		const selectedService = orderDetails.find(pOrderDetail => pOrderDetail.isSelected);

		let referenceId = selectedService.referenceId;

		let correctionPayload = {
			data: {
				Action: selectedAction.value,
				Compartment: resolveCompartment(selectedService.orderNoSrc),
				EnterpriseCode: `IKEA_${selectedService.countryCode}`,
				OrderNo: selectedService.orderNo,
				OrderNoSrc: selectedService.orderNoSrc,
				Owner: "isell",
				ReferenceId: referenceId,
				ClientSystem: selectedService.clientSystem
			}
		};
		let isArticleCancellation = selectedAction.value === "ISELL_Article_Cancellation_ISOM_UC9";

		if (isArticleCancellation) {
			let salesItemNumbers = [];
			const selectedArticles = selectedService.connectedArticles.where(article => article.isSelected).toArray();
			if (selectedArticles.length === 0) {
				throw new Error("Could not resolve article to process");
			} else {
				selectedArticles.forEach(selectedArticle => {
					salesItemNumbers.push(selectedArticle.externalRefId);
				});
			}
			correctionPayload.data = { ...correctionPayload.data, SalesItemNumber: [...salesItemNumbers] };
			if (
				(selectedService.deliveryStatus && selectedService.deliveryStatus.toUpperCase() === "COMPLETED") ||
				(selectedService.orderStatus && selectedService.orderStatus.toUpperCase() === "COMPLETED")
			) {
				console.log(`Removing Articles from Completed delivery. delivery No: ${selectedService.referenceId}, Order Number:${selectedService.orderNo}, Article's Ref Ids: ${[...salesItemNumbers]}`);
			}
		}

		//what if selectedService.isDummy == true? (i.e. the Process button was for some reason not disabled..)?
		return orderProcessingService.processOrder(correctionPayload, selectedService.countryCode).then(correctionResult => {
			if (correctionResult.errorData && correctionResult.errorData !== null && correctionResult.errorData !== undefined) {
				dispatch(actionCreators.setProcessingOrder({ isProcessingOrder: true, message: correctionResult.errorData.message }));
			} else {
				dispatch(actionCreators.setProcessingOrder({ isProcessingOrder: true, message: correctionResult.message }));
			}
		});
	};
}
